module.exports = __webpack_public_path__ + "media/images/Frame5085-174ac3f5.png";